import { createAsyncThunk } from '@reduxjs/toolkit';
import { ScheduleServices } from 'Services/axios/Schedule.Service';
import { checkFilter } from 'Features/Common/CommonUtils';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchSchedules = createAsyncThunk(
  'Schedules/fetchSchedules',
  async (filters) => {
    try {
      let filter = checkFilter(filters);
      const response = await ScheduleServices.getAll(filter);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const fetchQRCode = createAsyncThunk(
  'Schedules/fetchQRCode',
  async () => {
    try {
      const response = await ScheduleServices.QRCodePresence();
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const fetchDetailMemberClassSchedule = createAsyncThunk(
  'Schedules/fetchDetailMemberClassSchedule',
  async ({ classId, userId }) => {
    try {
      const response = await ScheduleServices.getDetailMemberClassSchedule(classId, userId);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const editAttendance = createAsyncThunk(
  'Schedules/editAttendance',
  async ({ attendanceId, is_attended }) => {
    try {
      const formData = new FormData();
      formData.append('is_attended', is_attended);
      await ScheduleServices.editAttendance(attendanceId, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitSchedules = createAsyncThunk(
  'Schedules/submitSchedules',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('class_id', data.class_id);
      formData.append('tentor_id', data.tentor_id);
      data.course_id && formData.append('course_id', data.course_id);
      data.material_id && formData.append('material_id', data.material_id);
      formData.append('name', data.name);
      formData.append('QR_start_at', data.QR_start_at);
      formData.append('session_start_at', data.session_start_at);
      formData.append('session_end_at', data.session_end_at);
      formData.append('place', data.place);
      formData.append('assignment_detail', data.assignment_detail || '');
      formData.append('assignment_deadline', data.assignment_deadline || '');

      let response;
      if (data.id) {
        response = await ScheduleServices.update(data.id, formData);
      } else {
        response = await ScheduleServices.create(formData);
      }
      toast.success('Sesi berhasil ' + (data.id ? 'diubah' : 'dibuat') + '.', {
        position: toast.POSITION.TOP_RIGHT,
      });
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteSchedules = createAsyncThunk(
  'Schedules/deleteSchedules',
  async (id) => {
    try {
      const response = await ScheduleServices.delete(id);
      toast.success('Sesi berhasil dihapus.', {
        position: toast.POSITION.TOP_RIGHT,
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const attachDetachUserToSchedule = createAsyncThunk(
  'Schedules/attachDetachUserToSchedule',
  async (data) => {
    try {
      const formData = new FormData();
      data.userId.forEach((user, index) => {
        formData.append(`user[${index}]`, user);
      });
      await ScheduleServices.attachDetachUserToSchedule(data.scheduleId, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const exportScheduleProgress = createAsyncThunk(
  'Schedules/exportScheduleProgress',
  async (id) => {
    try {
      const response = await ScheduleServices.exportScheduleProgress(id);
      const fileLink = response.data.file;
      window.open(fileLink, '_blank');
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);